<script setup lang="ts">

import { T } from '@tolgee/vue'
import { env } from '@/env'
import { onMounted } from 'vue'
import { useAnalytics } from '@/composables/analytics'

const { triggerEvent } = useAnalytics()

onMounted(() => {
  triggerEvent({
    event: 'show_qr_code',
  })
})
</script>

<template>
  <div class="text-dark-primary flex-1 h-full flex flex-col gap-y-4 items-center justify-center bg-white">
    <div class="text-center text-[40px] leading-[44px] font-bold -tracking-[0.8px]">
      <T
        key-name="loader.use_mobile"
        default-value="Play on your mobile"
      />
    </div>
    <img
      src="@/assets/images/qr-code.png"
      class="w-full h-auto max-w-[432px]"
    >
    <div class="text-[32px] leading-[35px] font-bold -tracking-[0.64px]">
      @{{ env.bot.username }}
    </div>
  </div>
</template>

<style scoped>
</style>
